module.exports = require('./LocaleWatcher')
